<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Đánh giá đơn hàng #{{id}}</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<!--<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">-->
		<div>
			<div class="p-6" v-if="isPopupActiveLocal">
				<vs-row class="mb-5">
					<vs-col vs-w="7" style="display: flex; vertical-align: middle;">
						<div class="w-full">
							<label for class="text-base vs-input--label">
								Người mua
							</label>
							<cbs-input type="text" v-model="nguoi_mua" class="w-full" readOnly/>
						</div>
					</vs-col>
					<vs-col vs-w="5" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Thời gian xuất
							</label>
							<cbs-input type="text" v-model="shipping_date" class="w-full" readOnly/>
						</div>
					</vs-col>
				</vs-row>

				<vs-row :key="indexLoaica" v-for="(detail, indexLoaica) in details">
					<vs-col vs-lg="4" vs-sm="4" style="display: flex; vertical-align: middle;" class="mb-5">
						<div class="w-full">
							<label for class="text-base vs-input--label">
								{{ detail.product ? detail.product.name : '' }}
							</label>
							<CbsMaskedInput
								dataType="int"
								class="vs-inputx vs-input--input normal"
								:userSetting="{}"
								:value="detail.quantity"
								readOnly
							/>
						</div>
					</vs-col>
					<vs-col vs-lg="3" vs-sm="3" style="display: flex; vertical-align: middle;" class="mb-5">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Đơn giá
							</label>
							<CbsMaskedInput
								dataType="int"
								class="vs-inputx vs-input--input normal"
								:userSetting="{}"
								:value="detail.price"
								readOnly
							/>
						</div>
					</vs-col>
					<vs-col vs-lg="5" vs-sm="5" style="display: flex; vertical-align: middle;" class="mb-5">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Thành tiền
							</label>
							<CbsMaskedInput
								dataType="int"
								class="vs-inputx vs-input--input normal"
								:userSetting="{}"
								:value="detail.quantity * detail.price"
								readOnly
							/>
						</div>
					</vs-col>
				</vs-row>
				<vs-row class="mb-5">
					<vs-col vs-lg="7" vs-sm="7" style="display: flex; vertical-align: middle;">
						<div class="w-full">
							<label for class="text-base vs-input--label">
								Tổng lượng (kg):
							</label>
							<CbsMaskedInput
								dataType="int"
								class="vs-inputx vs-input--input normal"
								:userSetting="{}"
								v-model.number="total_quantity"
								readOnly
							/>
						</div>
					</vs-col>
					<vs-col vs-lg="5" vs-sm="5" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Tổng tiền (vnd):
							</label>
							<CbsMaskedInput
								dataType="int"
								class="vs-inputx vs-input--input normal"
								:userSetting="{}"
								:value="total"
								readOnly
							/>
						</div>
					</vs-col>
				</vs-row>

				<vs-row class="mb-5">
					<vs-col vs-w="7" style="display: flex; vertical-align: middle;">
						<div class="w-full">
							<label for class="text-base vs-input--label">
								Tài xế
							</label>
							<cbs-input type="text" :value="driver_name + ' ('+driver_phone+')'" class="w-full" readOnly/>
						</div>
					</vs-col>
					<vs-col vs-w="5" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Số ghe
							</label>
							<cbs-input type="text" v-model="vehicle_no" class="w-full" readOnly/>
						</div>
					</vs-col>
				</vs-row>

				<fieldset class="fieldset-custom mb-5">
					<legend>Đánh giá</legend>
					<div class="mb-5">
						<div class="mb-5" style="overflow: hidden;" v-if="!type_variant">
							<vs-row class="mb-1" :key="indextr" v-for="(kcsOption, indextr) in kcsListOpts">
								<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
									<vs-checkbox :name="'kcs_option'+kcsOption.id" v-model="kcsOptions[kcsOption.id]" color="primary" :id="'kcs_option'+kcsOption.id" vs-value="1" />
									<label :for="'kcs_option'+kcsOption.id" class="text-base vs-input--label">
										{{ kcsOption.name }}
									</label>
								</vs-col>
							</vs-row>
						</div>
					</div>

					<div class="mb-5 mt-5">
						<label for class="text-base vs-input--label">
							Số bao đổi/trả
						</label>
						<!-- <cbs-input type="number" v-model="return_quantity" class="w-full" name="return_quantity" :data-vv-as="'Khối lượng bị trả lại (kg)'" :placeholder="`${$t('Input')} ${'Khối lượng bị trả lại (kg)'}`" /> -->
						<CbsMaskedInput
							dataType="int"
							class="vs-inputx vs-input--input normal"
							:userSetting="{}"
							v-model.number="return_quantity"
						/>
					</div>

					<div class="mb-5 mt-5" v-if="canRating">
						<label for class="text-base vs-input--label">
							Ghi chú
						</label>
						<vs-textarea height="100px" type="text" v-model="kcs_note" class="w-full" name="kcs_note" :data-vv-as="'Điền vào'" :placeholder="'Nhập những thông tin ghi nhận được'" />
					</div>

					<div class="mb-5">
						<label for class="text-base vs-input--label">
							Hình ảnh
							<span class="text-danger">*</span>:
						</label>
						<CbsUploadRefCustom
							value="value"
							:key="timeKey2"
							v-model="localAttachFile"
							accept="image/*"
							:limit="10"
							:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
							:dataValue="files"
						/>
						<span class="text-danger text-sm break-normal" v-show="customErrors != null">{{ customErrors }}</span>
					</div>
				</fieldset>
			</div>
		</div>
		<!--</PerfectScrollbar>-->

		<div class="flex justify-center" slot="footer" v-if="canRating">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Lưu lại</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";
import CbsMaskedInput from "@/components/cbs-masked-input/CbsMaskedInput";

let latPos = 0, lngPos = 0;
let packageMaps = {
	package_50: 'Số bao 50kg',
	package_70: 'Số bao 70kg',
};

export default {
	name: "ShippingForm",
	components: { vSelect, CbsDatePicker, CbsUploadRef, CbsUploadRefCustom, CbsMaskedInput },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			details: [],
			total: 0,
			total_quantity: 0,
			kcsListOpts: [
				{id: 'dat_chat_luong_bao_bi', name: 'Đạt chất lượng bao bì'},
				{id: 'dat_toc_do_xuat_hang', name: 'Đạt tốc độ xuất hàng'},
				{id: 'dat_tinh_can_than', name: 'Đạt tính cẩn thận'},
				{id: 'dam_bao_an_toan_lao_dong', name: 'Đảm bảo an toàn lao động'},
			],
			kcsOptions: {},
			currentPhotos: [],
			humidity: null,
			price_variant: false,
			packageMaps: packageMaps,
			packageValues: {
				package_50: null,
				package_70: null,
			},
			customErrors: null,
			timeKey: Date.now(),
			shippingMethodTypes: [
				{
					id: 1,
					name: 'Xe tải'
				},
				{
					id: 2,
					name: 'Ghe'
				},
				{
					id: 4,
					name: 'Xe ba gác'
				},
			],
			sell_id: null,
			buy_id: null,
			canView: false,
			canRating: false,
			kcs_accept: null,
			shipping_date: null,
			vehicle_type: null,
			verhicle_no: null,
			driver_name: null,
			driver_phone: null,
			shipping_address: null,
			supplier_rating: 0,
			kcs_note: null,
			return_quantity: null,
			storage_address: null,
			supplier_name: null,
			num_packaging: null,
			lat: 0,
			lng: 0,


			timeKey: Date.now(),
			files: [],
			value: {},
			product: null,
			supplier: null,
			quantity: null,
			price: null,
			address: null,
			cus_note: null,

			// 'supplier_name': null,
            'supper_phone': null,
            'supper_mst': null,
            'supplier_bankaccount': null,
            'supplier_bankname': null,
            'supplier_bankowner': null,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,
			code: null,
			photos: [],
			supplier_name: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() <= Date.now();
				}
			},

			nguoi_mua: null,
			mat_hang: null
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			try {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(position => {
						console.log('position: ', position);
						if (position.coords) {
							latPos = position.coords.latitude;
							lngPos = position.coords.longitude;
							console.log(latPos, lngPos);
						}
					});
				}
			} catch (exx) {
				console.log(exx.message);
			}

			console.log(this.data);

			// khoi_luong_ca_y_300: null,
			// khoi_luong_ca_y_400: null,
			// khoi_luong_ca_y_500: null,
			// khoi_luong_ca_chet_300: null,
			// khoi_luong_ca_chet_400: null,
			// khoi_luong_ca_chet_500: null,
			// khoi_luong_ca_dat: null,
			// packing_unit: null,
			// so_bao_ca_y: null,
			// so_bao_ca_dat: null,

			const { po, kcs_options, kcs_photos, creater, product, photos2, tested_date = null, packing_unit, so_bao_ca_y, so_bao_ca_dat, kcs_detail, type_variant, id , code, shipping_date, supplier_rating, vehicle_no, vehicle_type, quantity, kcs_accept, tested_note, return_quantity, driver_name, driver_phone, address, storage_address, supplier_name, photos = [], num_packaging, matching = {}, properties = {} } = this.data;
			if (po) {
				let {total, total_quantity, details} = po;
				this.total = total;
				this.total_quantity = total_quantity;
				this.details = details;
			} else {
				this.total = 0;
				this.total_quantity = 0;
				this.details = [];
			}

			const {sell_id, buy_id  } = matching || {};
			const {price_variant} = product || {};
			this.price_variant = price_variant;
			if (kcs_photos) {
				this.files = kcs_photos;
			} else {
				this.files = [];
			}
			if (kcs_options && Object.keys(kcs_options).length) {
				this.kcsOptions = kcs_options;
			} else {
				this.kcsOptions = {};
			}
			if (product) {
				this.mat_hang = product.name;
			} else {
				this.mat_hang = null;
			}
			if (creater) {
				this.nguoi_mua = creater.name;
			} else {
				this.nguoi_mua = null;
			}
			if (sell_id) {
				this.sell_id = sell_id;
			} else {
				this.sell_id = null;
			}
			if (packing_unit) {
				this.packing_unit = packing_unit;
			} else {
				this.packing_unit = null;
			}
			if (so_bao_ca_y) {
				this.so_bao_ca_y = so_bao_ca_y;
			} else {
				this.so_bao_ca_y = null;
			}
			if (so_bao_ca_dat) {
				this.so_bao_ca_dat = so_bao_ca_dat;
			} else {
				this.so_bao_ca_dat = null;
			}
			if (kcs_detail) {
				this.kcs_detail = kcs_detail;
				for (let k in kcs_detail) {
					this[k] = kcs_detail[k];
				}
			} else {
				this.kcs_detail = null;
			}
			if (supplier_name) {
				this.supplier_name = supplier_name;
			} else {
				this.supplier_name = null;
			}
			if (type_variant) {
				this.type_variant = type_variant;
			} else {
				this.type_variant = false;
			}
			if (code) {
				this.code = code;
			} else {
				this.code = null;
			}
			if (buy_id) {
				this.buy_id = buy_id;
			} else {
				this.buy_id = null;
			}

			if (photos) {
				this.photos = photos;
			}
			if (id) {
				this.id = id;
			} else {
				this.id = null;
			}
			if (shipping_date) {
				this.shipping_date = shipping_date;
			} else {
				this.shipping_date = null;
			}
			if (supplier_rating) {
				this.supplier_rating = supplier_rating;
			} else {
				this.supplier_rating = null;
			}
			if (vehicle_no) {
				this.vehicle_no = vehicle_no;
			} else {
				this.vehicle_no = null;
			}
			if (num_packaging) {
				this.num_packaging = num_packaging;
			} else {
				this.num_packaging = null;
			}
			if (vehicle_type) {
				this.vehicle_type = vehicle_type == 1 ? 'Xe tải' : (vehicle_type == 2 ? 'Ghe' : 'Xe ba gác');
			} else {
				this.vehicle_type = null;
			}
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (tested_date) {
				this.kcs_accept = kcs_accept ? '1' : '0';
			} else {
				this.kcs_accept = null;
			}
			// if (kcs_accept) {
			// 	this.kcs_accept = kcs_accept ? '1' : '0';
			// } else {
			// 	this.kcs_accept = '0';
			// }
			if (tested_note) {
				this.kcs_note = tested_note;
			} else {
				this.kcs_note = null;
			}
			if (return_quantity) {
				this.return_quantity = return_quantity;
			} else {
				this.return_quantity = null;
			}
			if (driver_name) {
				this.driver_name = driver_name;
			} else {
				this.driver_name = null;
			}
			this.driver_phone = driver_phone;
			if (address) {
				this.shipping_address = address;
			} else {
				this.shipping_address = null;
			}
			if (storage_address) {
				this.storage_address = storage_address;
			} else {
				this.storage_address = null;
			}
			console.log('Object.keys(properties).length: ', Object.keys(properties).length);
			if (properties && Object.keys(properties).length) {
				this.packageValues = properties;
				console.log('vao day nha');
			} else {
				console.log('day ne');
				for (let k in this.packageValues) {
					this.packageValues[k] = null;
				}
			}

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
	},
	computed: {
		localAttachFile: {
			get() {
				// console.log('this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				// console.log('set.value: ' , val);
				// console.log(typeof val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				if (this.files.length) {
					this.customErrors = null;
				}
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		this.getSuppliers();
		
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_view = false, shipping_can_rating = false } = permissions;
			if (shipping_can_view) {
				this.canView = true;
			}
			if (shipping_can_rating) {
				this.canRating = true;
			}
			this.userToken = token;
		}
	},
	methods: {

		changeReview(num) {
			this.supplier_rating = num;
		},
		checkReview(review, num) {
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				let photoFiles = this.files.map(item => item.id);
				if (!photoFiles.length) {
					this.customErrors = 'Cần vài hình thực tế để lưu lại';
					return;
				}
				if (result) {
					const dataObj = {
						id: this.id,
						kcs_note: this.kcs_note,
						lat: latPos,
						lng: lngPos,
						photos: photoFiles,
						return_quantity: this.return_quantity,
						is_xuathang: 1,
						kcs_options: this.kcsOptions
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			// if (this.supplier == 0) {
			// 	this.getSuppliers();
			// }
			// if (!this.id) {
			// 	this.initValues();
			// }
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Lưu thành công",
				},
			});

			this.$emit("closePopup");
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/kcsReviewShipping", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				console.log(error);
				this.$helper.notifyError({ context: this, options: {
					text: error,
				} });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>


<style>
 .fieldset-custom {
	padding: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
 }
</style>